import React from "react";

const LoadingSpinner = ({ size = "lg", className = "" }) => {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-16 w-16",
    lg: "h-32 w-32",
  };

  return (
    <div className={`flex items-center justify-center min-h-screen bg-theme-primary ${className}`}>
      <div
        className={`
          animate-spin rounded-full border-2 border-transparent
          border-t-accent-cyan border-r-accent-purple
          ${sizeClasses[size] || sizeClasses.lg}
        `}
      />
    </div>
  );
};

export default LoadingSpinner;
